import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlightSearch',
  standalone: true,
})
export class HighlightSearchPipe implements PipeTransform {
  transform(value: any, args: any): any {
    if (!args) {
      return value;
    }

    const regex = new RegExp(args, 'gi');
    const match = value.replaceAll(/<[^>]+>/gi, '').match(regex);

    if (!match) {
      return value;
    }

    return value.replace(regex, `<span class='pp-highlight'>${match[0]}</span>`);
  }
}
